import React from 'react'

const Integartion_Monitoring = React.lazy(() =>
  import('./components/FlipCardComponent/FlipCardComponent'),
)

const HomePage = React.lazy(() => import('./components/BAM/HomePage/HomePage'))
const BamSystem = React.lazy(() => import('./components/BAM/SystemFlow/SystemFlow'))
const BamFlowIntegration = React.lazy(() =>
  import('./components/BAM/IntegrationPage/IntegrationPage'),
)
const BamSystemFlow = React.lazy(() => import('./components/BAM/SystemFlow/SystemFlow'))
const AddNewFlow = React.lazy(() => import('./components/BAM/ConfigPage/ConfigPage'))
const AddNewSystem = React.lazy(() => import('./components/BAM/ConfigPage/ConfigPage'))
const AddNewIntegration = React.lazy(() => import('./components/BAM/ConfigPage/ConfigPage'))
const routes = [
  {
    path: '/',
    name: 'Integration Monitoring',
    element: Integartion_Monitoring,
  },
  {
    path: '/im',
    name: 'Integration Monitoring',
    element: Integartion_Monitoring,
  },
  {
    path: '/imt',
    name: '',
    element: HomePage,
  },
  {
    path: '/imt/systemflow',
    name: '',
    element: BamSystemFlow,
  },
  {
    path: '/imt/systemflow/system',
    name: '',
    element: BamSystem,
  },
  {
    path: '/imt/systemflow/system/integration',
    name: '',
    element: BamFlowIntegration,
  },
  {
    path: '/imt/addnewflow',
    name: '',
    element: AddNewFlow,
  },
  {
    path: '/imt/addnewsystem',
    name: '',
    element: AddNewSystem,
  },
  {
    path: '/imt/addnewintegration',
    name: '',
    element: AddNewIntegration,
  },
]

export default routes
